module.exports = "/_next/static/images/a8e686fd16c22744c1c42d0cbb877684-debit-card.svg";